import { css } from 'emotion';

export const titleStyles = css`
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #7f8287;
  margin-bottom: 20px;
`;
